/*
 * Rótulo do status da mensagem para o PROPONENTE e o PATROCINADOR (22/09/2026).
 *
 * "Pendente" é o nome do estado no workflow (a mensagem aguarda a liberação do
 * admin) e faz sentido na fila DELE. Para quem escreveu, porém, a palavra sugere
 * que o envio falhou — o proponente vê "Pendente" e conclui que a tela não
 * funcionou. O que o estado realmente diz a ele é que **o outro lado ainda não
 * viu** a mensagem.
 *
 * ⚠️ Só o RÓTULO muda. O valor continua "Pendente" no banco, na API e na
 * estilização (o `MessageStatus` decide a cor pelo status cru) — por isso este
 * helper devolve o texto e nunca é usado como chave de estilo.
 *
 * A tela do ADMIN mantém "Pendente" de propósito: lá é fila de trabalho, e
 * "Não visualizado" não diria o que ele precisa fazer.
 */
const COUNTERPART_LABELS = {
  Pendente: "Não visualizado",
};

/**
 * @param {string} status valor cru de `project_messages.status`
 * @returns {string} o texto a exibir na área comum
 */
export const messageStatusLabel = (status) =>
  COUNTERPART_LABELS[status] || status;

export default messageStatusLabel;
